import { render } from "./domain-action.vue?vue&type=template&id=29d4855e"
import script from "./domain-action.vue?vue&type=script&lang=js"
export * from "./domain-action.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__